import {
    SET_PARTNER_TYPES,
    SET_USER,
    MANAGE_LOADING_BASE_DATA,
    MANAGE_EDITING_USER } from './mutation-types.js';
import { partnerDataSvc } from '../shared/services/data-service-partner.js';

async function buildPartnerTypes() {
    const searchInfo = { pageSize: 200 };
    const partnerTypes = [];
    var pageInfo = await partnerDataSvc.loadPartnerTypes(searchInfo);
    if (pageInfo.successful) {
        partnerTypes.push.apply(partnerTypes, pageInfo.partnerTypes);
        while (pageInfo.nextPageLink) {
            searchInfo['pageLink'] = pageInfo.nextPageLink;
            pageInfo = await partnerDataSvc.loadPartnerTypes(searchInfo);
            partnerTypes.push.apply(partnerTypes, pageInfo.partnerTypes);
        }
    }
    return partnerTypes;
}

export default {
    async loadBaseData(context) {
        context.commit(MANAGE_LOADING_BASE_DATA, true);

        // load partner types
        const partnerTypes = await buildPartnerTypes();
        context.commit(SET_PARTNER_TYPES, partnerTypes);
        context.commit(MANAGE_LOADING_BASE_DATA, false);
    },
    setLoggedInUser(context, payload) {
        context.commit(MANAGE_EDITING_USER, true);

        // update user
        context.commit(SET_USER, payload);
        context.commit(MANAGE_LOADING_BASE_DATA, false);
   }
};